/* eslint-disable react/prop-types */
/* eslint-disable react/display-name */
/* eslint-disable no-unused-vars */
/* eslint-disable no-undef */
/* eslint-disable react-hooks/rules-of-hooks */
import React, { forwardRef, useState, useImperativeHandle } from "react";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import { useSelector } from "react-redux";
//EditLayoutButton
const saveButtonLayout = forwardRef(({prevfile, pageName}, ref) => {
  const translation = useSelector(state => state.root.translation);
  const MySwal = withReactContent(Swal);
  const [buttonLoader, setButtonLoader] = useState(false);
  const [data, setData] = useState(null);
  useImperativeHandle(ref, () => ({
    setData,
  }));

  // const {layoutGlobal} = useSelector((state) => state.root);
  const saveLayout = async (name) => {
    if (!data || !data.length) {
      // important check
    MySwal.fire({
      position: "top-end",
      icon: "info",
      title: "Layout already saved!",
      showConfirmButton: false,
      timer: 1500,
    });
      return;
    }
    let token = 'Bearer '+localStorage.getItem("accessToken");
    const payload = {...prevfile};
    payload[name] = data;
    setButtonLoader(true);
    try {
      console.log('data',data);
      // eslint-disable-next-line no-undef
      let updateTenantConfigs = await WizzUtils.pref.replaceTenantConfigs({token, type:name, data: data})

      if (updateTenantConfigs) 
      {
        localStorage.setItem("dashboardLayout", JSON.stringify(data));
      
        MySwal.fire({
          position: "top-end",
          icon: "success",
          title: "Your work has been saved",
          showConfirmButton: false,
          timer: 500,
        });
          
      }
      setButtonLoader(false);
    } catch (error) {
      console.log(error);
      setButtonLoader(false);
    }
  };
  return (
    <div className="save-layout-btn">
      <div className="dropdown">
        <button
          className="btn btn-primary me-3"
          type="button"
          onClick={() => saveLayout(pageName)}
        >
          {translation?.save_layout}
        </button>
      </div>
    </div>
  );
});

export default saveButtonLayout;
